import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { DividendHistoryItemDesktop } from './Desktop';
import { DividendHistoryItemMobile } from './Mobile';
import { DividendHistoryItemTablet } from './Tablet';
import { DividendHistoryItemTypes } from './types';

export const DividendHistoryItem: React.FC<DividendHistoryItemTypes.Props> = ({ item }) => {
  return useBreakpointValue({
    base: <DividendHistoryItemMobile item={item} />,
    sm: <DividendHistoryItemTablet item={item} />,
    lg: <DividendHistoryItemDesktop item={item} />,
  });
};
